import { render, staticRenderFns } from "./PermissionCreate.vue?vue&type=template&id=15de4e3e&"
import script from "./PermissionCreate.vue?vue&type=script&lang=js&"
export * from "./PermissionCreate.vue?vue&type=script&lang=js&"
import style0 from "./PermissionCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports